import Helper from "@/Helper";
export default {
  name: "summary",
  components: {},
  props: [],
  data() {
    return {
      loading: false,
      date_now: this.$moment(),
      users: null,
      checklist: {},
      summary: {},
      errors: {},
      item_reports: [],
      check_all: true,
      show_custom_checklist_item: false
    };
  },
  computed: {
    checklist_users() {
      return this.$store.getters["Audit/getUserOfChecklist"];
    }
  },
  mounted() {
    this.$loading.start();
    // this.loading = true;
    Promise.all([
      this.$store.dispatch("Checklist/showChecklist", {
        checklist: { id: this.$route.params.checklist_id }
      }),
      this.$store.dispatch("Summary/getChecklistItemReport", {
        checklist: { id: this.$route.params.checklist_id }
      }),
      this.$store.dispatch("Summary/getMinutesLast", {
        checklist: { id: this.$route.params.checklist_id }
      })
      // this.$store.dispatch('Audit/getUserOfChecklist', {checklist: {id: this.$route.params.checklist_id}}),
    ])
      .then(res => {
        console.log(res);
        this.checklist = res[0];
        this.item_reports = res[1];
        this.summary = res[2];
        // this.users = res[3].map(item => {
        //   var data = item
        //   data.users = item.users.sort((a, b) => a.position_order - b.position_order)
        //   return data
        // })
        this.item_reports.forEach(element => {
          element.select = true;
        });
        this.$loading.complete();
        this.loading = false;
      })
      .catch(errors => {
        this.$loading.fail();
        this.loading = false;
      });
  },
  methods: {
    create() {
      var ids = [];
      this.item_reports.forEach(element => {
        if (element.select) {
          ids.push(element.id);
        }
      });
      this.summary.list_items_report_alias = ids;
      this.summary.self_assessment = Helper.replaceHtml(
        this.summary.self_assessment
      );
      this.summary.conclusion = Helper.replaceHtml(this.summary.conclusion);
      this.$loading.start();
      // this.loading = true;
      this.$store
        .dispatch("Summary/createSummary", {
          checklist: { id: this.$route.params.checklist_id },
          summary: this.summary
        })
        .then(res => {
          this.$router.push("summary/" + res.id);
          this.$loading.complete();
          this.loading = false;
        })
        .catch(errors => {
          if (errors.status === 422) {
            this.errors = errors.data.error;
          }
          this.$loading.fail();
          this.loading = false;
        });
    },
    checkAll() {
      this.item_reports.forEach(element => {
        element.select = this.check_all;
      });
    },
    showCustom() {
      this.show_custom_checklist_item = !this.show_custom_checklist_item;
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/checklist/view/summary/summary.js